import React from "react";
import img1 from "../pages/Image/gorilla1.jpg";
import img2 from "../pages/Image/gorilla2.jpg";
import img3 from "../pages/Image/gorilla3.jpg";
import './destination.css';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel'; 
import Typography from '@mui/material/Typography';
import SimpleImageSlider from "react-simple-image-slider";
import Swipernew from "./Swipernew";
import slide_image_1 from '../pages/image1/IMG-20240928-WA0012.jpg';
import slide_image_2 from '../pages/image1/IMG-20240928-WA0013.jpg';
import slide_image_3 from '../pages/image1/IMG-20240928-WA0014.jpg';
import slide_image_4 from '../pages/image1/IMG-20240928-WA0015.jpg';

export default function Destination2() {

 const imageArray = [
  slide_image_1,
  slide_image_2,
  slide_image_3,
  slide_image_4,
 
];
  return (
    <>

<div>
<div>
            <Swipernew images={imageArray} />
        </div>
<div className="m-2 pt-5">
        <div className="container-fluid">
        <div className="ms-auto me-auto  bg2">

          <h1 className="text-center name11  ">
          3-Days Safari Tour of Queen Elizabeth National Park - Big Five Sighting
          </h1>
        </div>
         

          <h2>Description:</h2>
          <h3 className="ms-5 pt-3">
            <div>&emsp;&emsp;This safari will take you through Queen Elizabeth National Park, known for its sculptured landscape, rolling grassy hills, and variety of mammals.</div>
            <div>&emsp;&emsp;Queen Elizabeth National Park is Uganda’s most visited due to its Big Cat sightings including tree-climbing lions, leopards, and over 600 bird species.</div>
            <div>&emsp;&emsp;You will enjoy a boat safari on the Kazinga Channel, linking Lake Edward and George, where you’ll witness buffalo, elephants, and plenty of hippos.</div>
          </h3>
        </div>

        <div className="container-fluid p-5">
          <Box sx={{ padding: 2 }}>
            <Stepper orientation="vertical" activeStep={3}>
              {steps.map((step, index) => (
                <Step key={step.label1} color="black">
                  <StepLabel><h3>{step.label1}</h3></StepLabel>
                  <div className="bordernew">
                    <Typography variant="subtitle1" color="textblack" sx={{ ml: 2 }}>
                      <h4><b>{step.label}</b></h4>
                    </Typography>
                    <Typography sx={{ mt: 1, mb: 2, ml: 2 }}><h4>&emsp;{step.description}</h4></Typography>
                  </div>
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
      </div>
      <div class="btn-box text-white text-center">
                        <a href="https://wa.me/+971551579904" class="theme-btn btn-style-one rounded-3 m-4 ">Book Now</a>
                    </div>
</div>

     
    </>
  );
}

const steps = [
  {
    label1: 'Day - 1',
    label: 'Pick Up and Transfer to Queen Elizabeth National Park',
    description: `On this day, you will be met by our company driver early morning from your pick-up point and depart for Queen Elizabeth National Park. Upon reaching your accommodation, you can have an evening community walk or just relax at the lodge.`,
  },
  {
    label1: 'Day - 2',
    label: 'Whole Day in Queen Elizabeth National Park Game Drive and Boat Cruise',
    description: `You will enjoy a morning game drive to see the Big Five, including buffalo, elephants, lions, and more. In the afternoon, enjoy a local cuisine and boat cruise along Kazinga Channel to witness a variety of wildlife.`,
  },
  {
    label1: 'Day - 3',
    label: 'Chimpanzee Tracking in Kalinzu Forest and Return to Kampala/Entebbe',
    description: `After breakfast, head to Kalinzu Forest for chimpanzee tracking. Later, embark on the road trip back to Kampala or Entebbe, marking the end of the trip.`,
  }
];
